import { expensesAtom, expensesUnsyncedAtom } from "@/store/global";
import { userAtom } from "@/store/user";
import { useNetwork } from "@mantine/hooks";
import { useAtom } from "jotai";
import { useEffect } from "react";

export const useUploadUnsycedTransactions = () => {
  const [unsyncedExpenses] = useAtom(expensesUnsyncedAtom);
  const [, setExpenses] = useAtom(expensesAtom);
  const [user] = useAtom(userAtom);

  const networkStatus = useNetwork();

  useEffect(() => {
    if (user?.email && networkStatus.online && unsyncedExpenses.length > 0) {
      const syncExpenses = async () => {
        const res = await fetch("/api/transactions", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            expenses: unsyncedExpenses,
          }),
        });

        if (res.status === 200) {
          /**
           *  response: {
           *    new: [ "F5gkbULzZ5B90cGbDNUwr" ],
           *    updates: [ "123123" ],
           *    deleted: [ "123123" ]
           *  }
           */

          const data = (await res.json()) as {
            new: string[];
            deleted: string[];
            updates: string[];
          };

          setExpenses((draft) => {
            // Filter out duplicate expenses
            const uniqueExpenses = draft.expenses.filter(
              (expense, index, self) => self.findIndex((t) => t.id === expense.id) === index,
            );

            // Clear the draft array and push unique expenses
            draft.expenses.length = 0;
            draft.expenses.push(...uniqueExpenses);

            // Update the draft array based on the data
            draft.expenses.forEach((expense, index) => {
              if (data.new.includes(expense.id) || data.updates.includes(expense.id)) {
                expense.sync = true;
              } else if (data.deleted.includes(expense.id)) {
                draft.expenses.splice(index, 1);
              }
            });
          });
        }
      };

      syncExpenses();
    }
  }, [networkStatus, unsyncedExpenses, user?.email]);

  return null;
};
